import type { ReactNode } from "react";

/** The design's line icons. 24-unit grid, stroke follows currentColor. */

type P = { size?: number };

function Svg({ size = 20, children, width = 1.8 }: P & { children: ReactNode; width?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={width}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}

export const IconChat = (p: P) => <Svg {...p}><path d="M4 5h16v11H9l-5 4z" /></Svg>;
export const IconDoc = (p: P) => <Svg {...p}><path d="M6 3h9l4 4v14H6z" /><path d="M14 3v5h5" /></Svg>;
export const IconDocLines = (p: P) => (
  <Svg {...p}><path d="M6 3h9l4 4v14H6z" /><path d="M14 3v5h5M9 13h7M9 17h5" /></Svg>
);
export const IconShield = (p: P) => <Svg {...p}><path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z" /></Svg>;
export const IconMemory = (p: P) => (
  <Svg {...p}>
    <ellipse cx="12" cy="6" rx="7" ry="3" />
    <path d="M5 6v12c0 1.7 3.1 3 7 3s7-1.3 7-3V6M5 12c0 1.7 3.1 3 7 3s7-1.3 7-3" />
  </Svg>
);
export const IconClip = (p: P) => (
  <Svg {...p}><path d="M21 11l-8.5 8.5a5 5 0 0 1-7-7L14 4a3.5 3.5 0 0 1 5 5l-8.5 8.5a2 2 0 0 1-3-3L15 7" /></Svg>
);
export const IconSend = (p: P) => <Svg {...p} width={2}><path d="M12 19V5M5 12l7-7 7 7" /></Svg>;
export const IconChevron = (p: P) => <Svg {...p} width={2}><path d="M9 6l6 6-6 6" /></Svg>;
export const IconAlignLeft = (p: P) => <Svg {...p} width={2}><path d="M4 6h16M4 10h10M4 14h16M4 18h10" /></Svg>;
export const IconAlignCenter = (p: P) => <Svg {...p} width={2}><path d="M4 6h16M7 10h10M4 14h16M7 18h10" /></Svg>;
export const IconAlignRight = (p: P) => <Svg {...p} width={2}><path d="M4 6h16M10 10h10M4 14h16M10 18h10" /></Svg>;
export const IconAlignJustify = (p: P) => <Svg {...p} width={2}><path d="M4 6h16M4 10h16M4 14h16M4 18h16" /></Svg>;
export const IconListBullet = (p: P) => (
  <Svg {...p} width={2}><path d="M9 6h11M9 12h11M9 18h11" /><circle cx="4.5" cy="6" r="1" /><circle cx="4.5" cy="12" r="1" /><circle cx="4.5" cy="18" r="1" /></Svg>
);
export const IconListNumber = (p: P) => (
  <Svg {...p} width={2}><path d="M10 6h10M10 12h10M10 18h10M4 5l1.5-1V9M3.5 13.5a1.5 1.5 0 1 1 2.5 1.2L3.5 18H6" /></Svg>
);
export const IconTable = (p: P) => <Svg {...p}><rect x="3" y="5" width="18" height="14" rx="1.5" /><path d="M3 10h18M3 14.5h18M9 5v14M15 5v14" /></Svg>;
export const IconUndo = (p: P) => <Svg {...p} width={2}><path d="M9 7L4 12l5 5M4 12h11a5 5 0 0 1 0 10h-2" /></Svg>;
export const IconRedo = (p: P) => <Svg {...p} width={2}><path d="M15 7l5 5-5 5M20 12H9a5 5 0 0 0 0 10h2" /></Svg>;
export const IconExpand = (p: P) => <Svg {...p} width={2}><path d="M14 4h6v6M10 20H4v-6M20 4l-7 7M4 20l7-7" /></Svg>;
export const IconDownload = (p: P) => <Svg {...p} width={2}><path d="M12 4v11M7 10l5 5 5-5M5 20h14" /></Svg>;
export const IconRule = (p: P) => <Svg {...p} width={2}><path d="M4 12h16" /></Svg>;
export const IconPlus = (p: P) => <Svg {...p} width={2}><path d="M12 5v14M5 12h14" /></Svg>;
export const IconBack = (p: P) => <Svg {...p} width={2}><path d="M15 6l-6 6 6 6" /></Svg>;
export const IconInfo = (p: P) => <Svg {...p}><circle cx="12" cy="12" r="9" /><path d="M12 8v5M12 16h.01" /></Svg>;
export const IconPencil = (p: P) => <Svg {...p}><path d="M4 20h4L19 9l-4-4L4 16z" /></Svg>;
export const IconBin = (p: P) => (
  <Svg {...p}><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3" /></Svg>
);
export const IconMenu = (p: P) => <Svg {...p} width={2}><path d="M4 7h16M4 12h16M4 17h16" /></Svg>;
